import { mutatorAction } from 'satcheljs';
import store from '../store/Store';
import type { AutoPublishState } from '../store/schema/BookWithMeOrganizerStore';

/**
 * Action to update the newUserAutoPublishValue value
 */
export default mutatorAction(
    'setNewUserAutoPublishState',
    function setNewUserAutoPublishState(autopublishState: AutoPublishState) {
        store.newUserAutoPublishState = autopublishState;
    }
);
